module.exports = __webpack_public_path__ + "img/logo1.546b00e6.png";